import { render, staticRenderFns } from "./TableRiskAppraisalBsgs.vue?vue&type=template&id=d878cde0&scoped=true&"
import script from "./TableRiskAppraisalBsgs.vue?vue&type=script&lang=js&"
export * from "./TableRiskAppraisalBsgs.vue?vue&type=script&lang=js&"
import style0 from "./TableRiskAppraisalBsgs.vue?vue&type=style&index=0&id=d878cde0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d878cde0",
  null
  
)

export default component.exports